import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import { format } from 'date-fns';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiCopy, FiX, FiCheckCircle } = FiIcons;

const EnquiryReplyModal = ({ isOpen, onClose, enquiry }) => {
  const { getEffectiveTenantName } = useAuth();
  const [copySuccess, setCopySuccess] = useState(false);
  const businessName = getEffectiveTenantName() || 'Our Business';

  if (!enquiry) return null;

  const { email, full_name, service_requested, message, created } = enquiry;
  const formattedDate = created ? format(new Date(created), 'MMM dd, yyyy') : 'N/A';
  const subject = service_requested ? `Enquiry: ${service_requested} - ${businessName}` : `Your enquiry with ${businessName}`;

  const emailBody = `Hi ${full_name || 'there'},\n\nThank you for contacting ${businessName}.\n\nWe received your enquiry on ${formattedDate} regarding ${service_requested || 'our services'}.\n\nYour message: "${message || '(No message provided)'}"\n\nOur team will review this and get back to you shortly.\n\nRegards,\n${businessName}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(emailBody);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 3000);
    } catch { alert("Copy failed. Please copy manually."); }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
          <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-white rounded-lg p-6 max-w-xl w-full shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold flex items-center"><SafeIcon icon={FiMail} className="mr-2" /> Reply Helper</h2>
              <button onClick={onClose}><SafeIcon icon={FiX} className="w-5 h-5" /></button>
            </div>
            <div className="bg-gray-50 p-4 rounded-md mb-6 border border-gray-200">
              <p className="text-xs font-bold text-gray-500 uppercase mb-2">To: {email}</p>
              <p className="text-xs font-bold text-gray-500 uppercase mb-4">Subject: {subject}</p>
              <pre className="text-sm text-gray-800 whitespace-pre-wrap font-sans">{emailBody}</pre>
            </div>
            <div className="flex gap-3">
              <button onClick={handleCopy} className="flex-1 bg-gray-100 py-2 rounded font-bold hover:bg-gray-200 flex items-center justify-center">
                <SafeIcon icon={FiCopy} className="mr-2" /> {copySuccess ? 'Copied!' : 'Copy Body'}
              </button>
              <button onClick={() => window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`} className="flex-1 bg-blue-600 text-white py-2 rounded font-bold hover:bg-blue-700">
                Open in Email
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default EnquiryReplyModal;